import { Component, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-management-dashboard',
  standalone: true,
  imports: [
    MatCardModule,
    MatIconModule
  ],
  templateUrl: './user-management-dashboard.component.html',
  styleUrl: './user-management-dashboard.component.scss'
})
export class UserManagementDashboardComponent implements OnInit {

  constructor(
    private router: Router
  ) {
  }

  ngOnInit(): void {
    // Initialization logic here
  }

  navigateToManageUserRequests() {
    this.router.navigate(['/app/user-management/user-requests']);
  }

  navigateToManageResidents() {
    this.router.navigate(['/app/user-management/manage-residents']);
  }

}
